/**
 * Urban Entity Color Utilities
 *
 * @remarks
 * Paleta de colores por entityType para uso en UI (lista, filtros, mapa).
 * Extraído de useUrbanEntitiesLayer para permitir reutilización
 * en contextos sin dependencia de MapLibre.
 *
 * @module urban-inventory/utils
 */

export const ENTITY_TYPE_COLORS: Record<string, string> = {
  tree: '#22c55e',
  streetlight: '#eab308',
  waste_container: '#f97316',
  transit_stop: '#6366f1',
  bench: '#a78bfa',
  traffic_light: '#ef4444',
  fountain: '#38bdf8',
  waste_depot: '#fb923c',
  waste_hotspot: '#ec4899',
  building_centroid: '#94a3b8',
  default: '#64748b',
};

export function colorForType(entityType: string): string {
  return ENTITY_TYPE_COLORS[entityType] ?? ENTITY_TYPE_COLORS.default;
}
